import api from '../../../services/Api';
import { IAuditoriaCaixaResultado } from '../interfaces/IAuditoriaCaixa';

export const AuditoriaCaixaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaCaixaResultado> {
    const response = await api.get<IAuditoriaCaixaResultado>('auditoria-caixa/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoSaldoCredor: '',
        fundamentacaoEspecie: '',
        fundamentacaoBeneficioIndireto: '',
        saldoCredor: [],
        operacoesEspecie: [],
        beneficioIndireto: [],
      }
    );
  },
};
